<template>
  <div class="content p-1 ms-2 me-2 ms-lg-4 me-lg-4">
    
    <h6 class="page_text_grey">總覽</h6>
    <div class="w-100" v-if="stats_data[0]">
        <div class="alert alert-success d-flex align-items-center" role="alert">
            <font-awesome-icon :icon="['fas', 'check-circle']" />
            <div class="ms-2">
                所有案場運作正常
            </div>
        </div>
    </div>
    <div class="w-100"  v-if="stats_data[1]['str'] != ''">
        <div class="alert alert-danger d-flex align-items-center" role="alert">
            <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
            <div class="ms-2">
                {{stats_data[1]['str']}}有一級警報發生中
            </div>
        </div>
    </div>
    <div class="w-100" v-if="stats_data[2]['str'] != ''">
        <div class="alert alert-warning d-flex align-items-center" role="alert">
            <font-awesome-icon :icon="['fas', 'exclamation']" />
            <div class="ms-2">
                {{stats_data[2]['str']}}有二級警報發生中
            </div>
        </div>
    </div>
    <div class="w-100" v-if="stats_data[3]['str'] != ''">
        <div class="alert alert-secondary d-flex align-items-center" role="alert">
            <font-awesome-icon :icon="['fas', 'times']" />
            <div class="ms-2">
                {{stats_data[3]['str']}}有斷線警報發生中
            </div>
        </div>
    </div>

    <h6 class="page_text_grey mt-2">警報列表</h6>
    <div class="col-12 col-lg-12 alarm_table">
        <div class="w-100 row  alarm_table_header pt-2 pb-2 fw-bold m-0 d-none d-lg-flex">
            <div class="col-1 text-center">
                <label class="fs-6">案場</label>
            </div>
            <div class="col-2 text-center">
                <label class="fs-6">設備</label>
            </div>
            <div class="col-1 text-center">
                <label class="fs-6">警報類型</label>
            </div>
            <div class="col-4 text-center">
                <label class="fs-6">警報名稱</label>
            </div>
            <div class="col-2 text-center">
                <label class="fs-6">警報發生</label>
            </div>
            <div class="col-2 text-center">
                <label class="fs-6">警報修復</label>
            </div>
            <div class="col-1 text-center">
                
            </div>     
        </div>

        <div class="w-100 alarm_table_body">
            <transition-group :style="table_transition">
                <div class="row m-0 alarm_table_content mt-2 mt-lg-0" v-for="alarm_i in alarm_data" v-bind:key="alarm_i['ID']">
                    <div class="col-12 d-lg-none mt-2"></div>
                    <div class="col-12 col-lg-1 my-auto">
                        <div class="d-flex d-lg-none">
                            <label class="fs-6 fw-bold">案場：</label>
                            <label class="fs-6">{{alarm_i["PV"]}}</label>
                            <div class="d-flex justify-content-center ms-auto" v-if="alarm_i['level'] == 1">
                                <font-awesome-icon class="text-danger" :icon="['fas', 'exclamation-triangle']" />
                                <label class="fs-7">一級警報</label>
                            </div>
                            <div class="d-flex justify-content-center ms-auto" v-else-if="alarm_i['level'] == 2">
                                <font-awesome-icon class="text-warning" :icon="['fas', 'exclamation']" />
                                <label class="fs-7">二級警報</label>
                            </div>
                            <div class="d-flex justify-content-center ms-auto" v-else-if="alarm_i['level'] == 3">
                                <font-awesome-icon class="text-secondary" :icon="['fas', 'times']" />
                                <label class="fs-7">斷線</label>
                            </div>
                        </div>
                        <label class="fs-6 w-100 text-center d-none d-lg-block">{{alarm_i["PV"]}}</label>
                    </div>
                    <div class="col-12 d-lg-none mt-2 mb-2" style="border-bottom: 0.25px solid black;"></div>
                    <div class="col-12 col-lg-2 my-auto">
                        <div class="d-lg-none">
                            <label class="fs-6 fw-bold d-lg-none">設備：</label>
                            <label class="fs-6 d-lg-none">{{alarm_i["name"]}}</label>
                        </div>
                        <label class="fs-6 w-100 text-center d-none d-lg-block">{{alarm_i["name"]}}</label>
                    </div>
                    <div class="col-12 col-lg-1 my-auto">
                        <div class="d-lg-none">
                            <label class="fs-6 fw-bold d-lg-none">警報類型：</label>
                            <label class="fs-6 d-lg-none">{{alarm_i["group"]}}</label>
                        </div>
                        <label class="fs-6 w-100 text-center d-none d-lg-block">{{alarm_i["group"]}}</label>
                    </div>
                    <div class="col-12 col-lg-4 text-center my-auto">
                        <div class="d-flex d-lg-block">
                            <label class="fs-6 fw-bold d-lg-none my-auto">警報名稱：</label>
                            <div>
                                <div class="d-none d-lg-flex justify-content-center" v-if="alarm_i['level'] == 1">
                                    <font-awesome-icon class="text-danger" :icon="['fas', 'exclamation-triangle']" />
                                    <label class="fs-7">一級警報</label>
                                </div>
                                <div class="d-none d-lg-flex justify-content-center" v-else-if="alarm_i['level'] == 2">
                                    <font-awesome-icon class="text-warning" :icon="['fas', 'exclamation']" />
                                    <label class="fs-7">二級警報</label>
                                </div>
                                <div class="d-none d-lg-flex justify-content-center" v-else-if="alarm_i['level'] == 3">
                                    <font-awesome-icon class="text-secondary" :icon="['fas', 'times']" />
                                    <label class="fs-7">斷線</label>
                                </div>
                                <label class="fs-6">{{alarm_i["event"]}}</label>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 d-lg-none mt-2 mb-2" style="border-bottom: 0.25px solid black;"></div>
                    <div class="col-12 col-lg-2 my-auto">
                        <div class="d-lg-none">
                            <label class="fs-6 fw-bold d-lg-none">警報發生：</label>
                            <label class="fs-6 d-lg-none">{{alarm_i["time"]}}</label>
                        </div>
                        <label class="fs-6 w-100 text-center d-none d-lg-block">{{alarm_i["time"]}}</label>
                    </div>
                    <div class="col-12 col-lg-2 my-auto">
                        <div class="d-lg-none mb-2">
                            <label class="fs-6 fw-bold d-lg-none">警報修復：</label>
                            <label class="fs-6 d-lg-none">{{alarm_i["returntime"]}}</label>
                        </div>
                        <label class="fs-6 w-100 text-center d-none d-lg-block">{{alarm_i["returntime"]}}</label>
                    </div>
                </div>
            </transition-group>
            
           
           
        </div>


        <div class="w-100 alarm_table_footer pt-2 pb-2 d-flex justify-content-between justify-content-lg-center">
                <md-icon class="footer_icon" @click.native="change_page(1)">first_page</md-icon>
                <md-icon class="footer_icon" @click.native="change_page(2)">chevron_left</md-icon>
                <div class="col-1 text-white text-center">
                    <label class="fs-5">{{current_page}}</label>
                    <label class="fs-6" style="color: orange;">/</label>
                    <label class="fs-7">{{total_page}}</label>
                </div>
                <md-icon class="footer_icon" @click.native="change_page(3)">chevron_right</md-icon>
                <md-icon class="footer_icon" @click.native="change_page(4)">last_page</md-icon>
       
            
        </div>
    </div>

    
   
    

  </div>
</template>

<script>


export default {
 
  data() {
    return {
      current_page: 1,
      total_page: 1,
      alarm_data: [],
      stats_data: {},
      page_direction: "to",
    }
  },
  methods: {
    alarm_get(){
        let that = this
        this.axios.get("/alarm_get", {
            params:{
                page: this.current_page
            }
        })
        .then(function (data) {
            //console.log(data.data)
            that.total_page = data.data.data['total_page']
            that.alarm_data = data.data.data['alarm_data']
            that.stats_data = data.data.data['stats_data']
        })
    },
    change_page(mode){
        switch(mode){
            case 1:
                this.current_page = 1
                this.page_direction = "back"
                break
            case 2:
                (this.current_page > 1)? this.current_page-=1 : this.current_page=1
                this.page_direction = "back"
                break
            case 3:
                (this.current_page < this.total_page)? this.current_page+=1 : this.current_page=this.total_page
                this.page_direction = "to"
                break
            case 4:
                this.current_page = this.total_page
                this.page_direction = "to"
                break
            default:
                break
        }
        this.alarm_get()
    },
    
  },
  computed:{
      table_transition(){
            switch(this.page_direction){
                case "to":
                    return "--table_transition: 30px"
                    break
                case "back":
                default:
                    return "--table_transition: -30px"
                    break
          }
      }
  },
  mounted(){
      this.alarm_get()
      this.syncdata = setInterval(this.alarm_get, 5000)
  },
  destroyed(){
    clearInterval(this.syncdata)
  }
};
</script>
<style>
    .page_text_grey{
        color:  #495057 !important;
    }
    .alarm_table{
        -webkit-box-shadow: -1px 1px 6px 0px rgba(0,0,0,0.52);
        -moz-box-shadow: -1px 1px 6px 0px rgba(0,0,0,0.52);
        box-shadow: -1px 1px 6px 0px rgba(0,0,0,0.52);
    }
    .alarm_table_header{
        background-color: rgba(255, 193, 7, 0.63);
        /* border: 0.5px solid gray; */
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        /* border-bottom: 1px solid black; */
    }
    .alarm_table_footer{
        background-color: rgb(59, 59, 59);
        /* border: 0.5px solid gray; */
        border-bottom-left-radius: 3px;
        border-bottom-right-radius: 3px;
        /* border-bottom: 1px solid black; */
    }
    .alarm_table_body{
        /* border-left: 0.5px solid gray;
        border-right: 0.5px solid gray;
        border-bottom: 0.5px solid gray; */
    }
    .alarm_table_content{
        background-color: rgba(255, 255, 255);
        border-bottom: 0.5px solid gray;
    }
    .footer_icon{
        color: white !important;
        width: 24px !important;
        height: 24px !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
    }
    .footer_icon:hover{
        color: orange !important;
    }
    /* Transition Animation */
    .v-enter-active{
        transition: all 1s;
    }
    .v-enter{
        opacity: 0;
        transform: translateX(var(--table_transition));
    }
    
    
    @media (max-width: 991px) {
        .alarm_table_body .alarm_table_content:nth-child(2n+1){
            background-color: rgb(249, 231, 200);
        }
        .alarm_table_content{
            -webkit-box-shadow: -1px 1px 6px 0px rgba(0,0,0,0.52);
            -moz-box-shadow: -1px 1px 6px 0px rgba(0,0,0,0.52);
            box-shadow: -1px 1px 6px 0px rgba(0,0,0,0.52);
        }
    }
</style>